// extracted by mini-css-extract-plugin
export default {"container":"UF_Y6pUWth2sTV8f5gEJ"};